import { render, staticRenderFns } from "./QuoteImageCategory.vue?vue&type=template&id=49e00c5f&scoped=true"
import script from "./QuoteImageCategory.vue?vue&type=script&lang=js"
export * from "./QuoteImageCategory.vue?vue&type=script&lang=js"
import style0 from "./QuoteImageCategory.vue?vue&type=style&index=0&id=49e00c5f&prod&lang=scss&scoped=true"
import style1 from "./QuoteImageCategory.vue?vue&type=style&index=1&id=49e00c5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e00c5f",
  null
  
)

export default component.exports